/**
 * #72 fix (2026-05-17): migrated to web-vitals v4 API.
 *  - getFID → onINP (FID was removed from Chrome CrUX March 2024; INP is the
 *    replacement metric that captures full interaction latency, not just first).
 *  - get* prefix → on* prefix (v3+ API rename).
 *  - ReportHandler → MetricWithAttribution / Metric type (v4 unified type).
 *
 * The web-vitals package version in package.json must be ^4.0.0; v2.1.4
 * is still listed in dependencies — update it as part of this fix's deploy.
 */

import type { Metric } from 'web-vitals';

type Reporter = (metric: Metric) => void;

const reportWebVitals = (onPerfEntry?: Reporter) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
